// Types
export const SET_TEST = 'app/manual/SET_TEST';
export const SET_AGREE = 'app/manual/SET_AGREE';
// Reducer
export const INITIAL_STATE = {
  test: null,
  agree: false,
};

export default function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case SET_TEST:
      return {
        ...state,
        test: action.payload,
      };
    case SET_AGREE:
      return {
        ...state,
        agree: action.payload,
      };
    default:
      return state;
  }
}

// Action creators
export const setTest = (test) => ({
  type: SET_TEST,
  payload: test,
});

export const setAgree = (agree) => ({
  type: SET_AGREE,
  payload: agree,
});
